// extracted by mini-css-extract-plugin
export var fullGrid = "_3j-3";
export var pdpPreviewContainer = "_3j-1";
export var previewContainer = "_3j-0";
export var togglePreviewContainer = "_3j-2";